import { useEffect, useMemo } from 'react';

// Lightweight CSS/SVG AI network — no extra deps
export default function AINetwork({ density = 30, className = '' }) {
  const nodes = useMemo(() => {
    return Array.from({ length: density }).map((_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      r: 1 + Math.random() * 2,
      d: 2 + Math.random() * 4,
    }));
  }, [density]);

  const lines = useMemo(() => {
    const arr = [];
    for (let i = 0; i < nodes.length; i++) {
      for (let j = i + 1; j < nodes.length; j++) {
        const dx = nodes[i].x - nodes[j].x;
        const dy = nodes[i].y - nodes[j].y;
        if (Math.sqrt(dx * dx + dy * dy) < 18) {
          arr.push({ x1: nodes[i].x, y1: nodes[i].y, x2: nodes[j].x, y2: nodes[j].y });
        }
      }
    }
    return arr;
  }, [nodes]);

  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} aria-hidden>
      <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
        {lines.map((l, i) => (
          <line
            key={i}
            x1={l.x1} y1={l.y1} x2={l.x2} y2={l.y2}
            stroke="rgba(34,211,238,0.18)" strokeWidth="0.08"
          />
        ))}
        {nodes.map((n) => (
          <circle key={n.id} cx={n.x} cy={n.y} r={n.r * 0.18} fill="#22D3EE">
            <animate attributeName="opacity" values="0.3;1;0.3" dur={`${n.d}s`} repeatCount="indefinite" />
          </circle>
        ))}
      </svg>
    </div>
  );
}
